module.exports = __webpack_public_path__ + "fonts/9d6c1a5.otf";